// extracted by mini-css-extract-plugin
export default {"heading":"FAQ_heading__553Kd","icon":"FAQ_icon__7q9MP","accordion":"FAQ_accordion__jZDPN"};